import { render, staticRenderFns } from "./MemoCategoryForm.vue?vue&type=template&id=2f957107&"
import script from "./MemoCategoryForm.vue?vue&type=script&lang=js&"
export * from "./MemoCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports